module.exports = __webpack_public_path__ + "img/fire.4d6c6dc2.svg";